









































import { PropType, computed, defineComponent } from '@vue/composition-api';
import { AdgroupFormData, AttributionStatisticType } from '@tt4b/ttam-enums';
import { trackEvent } from '@tt4b/ttam-utils';
import QuestionTooltip from '@/components/common/question-tooltip/index.vue';

export default defineComponent({
  name: 'AttributionStatisticTypeSetting',

  components: { QuestionTooltip },

  props: {
    disabled: { type: Boolean, default: false },
    adgroupData: { type: Object as PropType<AdgroupFormData>, required: true },
  },

  setup(props, { emit }) {
    const eventParam = computed(() => {
      const { externalAction, externalType, optimizeGoal, adRefPixelId, adRefAppId, inventoryFlow } = props.adgroupData;

      return {
        optimization_type: externalType,
        optimization_goal: optimizeGoal,
        pixel_id: adRefPixelId,
        optimization_event: externalAction,
        app_id: adRefAppId,
        placement: inventoryFlow.join(','),
      };
    });

    const _attributionStatisticType = computed({
      get: () => props.adgroupData.attributionStatisticType,
      set: val => {
        trackEvent('ttam_adgroup_statistic_type_click', eventParam.value);
        emit('change', { attributionStatisticType: val });
      },
    });

    return {
      AttributionStatisticType,
      _attributionStatisticType,
    };
  },
});
